import { BaseParam } from "./BaseParams";

export class GetArticleParams extends BaseParam {
    ANDLogic = false
    CategoryId
    publicationDateFrom
    publicationDateTo

    constructor(state) {
        super(state)
        if (state == null)
            state = {};

        const { id = null, editionId = null, editionNumber = '', occhiello = '', title = '', summary = '', signature = '', text = '', isOnline = undefined, magazineName= ''} = state;

        this.id = id;
        this.editionId = editionId;
        this.editionNumber = editionNumber;
        this.magazineName = magazineName;
        this.occhiello = occhiello;
        this.title = title;
        this.summary = summary;
        this.signature = signature;
        this.text = text;
        this.isOnline = isOnline;
        this.ordering.orderPropertyName = 'competenceDateFrom';
        this.ordering.order = -1;
    }
}



// WEBPACK FOOTER //
// ./src/APIModels/GetArticleParams.js